<template>
  <div class="brandSelect">
    <v-select :items="brands"
              v-show="brands.length > 1"
              item-text="name"
              item-value="id"
              label="ブランドを選択してください。"
              no-data-text="ブランドがありません。"
              v-model="brandId"
              @change="searchBrand"
              class="selectBox"
              hide-details
              outline
              solo
    >
    </v-select>
    <div class="brandTxt" v-show="brands.length === 1">{{brands[0].name}}</div>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'
import eventBus from '@/event_bus'
import eventType from '@/constants/eventType'

export default {
  data: () => {
    return {
      brands: [],
      brandId: '',
      brandName: '',
      brandInfo: {}
    }
  },
  created () {
    if (this.$route.path.indexOf('/ticket/') >= 0) {
      this.ticketInitialize()
    } else {
      this.initialize()
    }
  },
  computed: {
    ...mapGetters([
      'currentBrandId',
      'currentBrandName',
      'ticketAgentId',
      'currentTicketBrandId',
      'currentTicketBrandName'
    ])
  },
  methods: {
    ...mapMutations([
      'changeCurrentBrandId',
      'changeCurrentBrandName',
      'changeTicketBrandId',
      'changeTicketBrandName'
    ]),
    initialize () {
      this.axios.get('/api/agent/fetchBrands').then(result => {
        if (result.data.code === 0) {
          this.brands = result.data.data
          if (this.currentBrandId) {
            this.brandId = this.currentBrandId
            this.brandName = this.currentBrandName
            // currentBrandId 만 존재하는 문제가 있어, brandName 이 null 일 경우 받아온 데이터 내에서 한번 더 찾기로 한다.
            if (this.brandName === null && this.brands.length > 0) {
              try {
                this.brandName = this.brands.filter(b => b.id === this.brandId)[0].name
              } catch (e) {}
            }
          } else {
            this.brandId = this.brands[0].id
            this.brandName = this.brands[0].name
            this.changeCurrentBrandId(this.brandId)
            this.changeCurrentBrandName(this.brandName)
          }
          this.searchBrand()
        } else {
          this.$alertMsg(result.data.message)
        }
      })
    },
    searchBrand () {
      let brandIndex = this.brands.findIndex((item, i) => item.id === this.brandId)
      let brand = this.brands[brandIndex]
      this.changeCurrentBrandId(brand.id)
      this.changeCurrentBrandName(brand.name)
      eventBus.$emit(eventType.FETCH_BRAND_INFO, this.currentBrandId)
      eventBus.$emit('brand-loading-complete')
    },
    ticketInitialize () {
      if (!this.ticketAgentId) {
        this.$alertMsg('チケット使用権限がありません。')
        this.$router.push('/')
        return
      }
      this.axios.get(`/gateway/ticket/agent/${this.ticketAgentId}/brands`).then(result => {
        if (result.data.code === 0) {
          const data = result.data.data
          this.brands = []
          if (data.length === 0) {
            this.$alertMsg('接続されたチケットブランド情報が存在しません。')
            this.$router.push('/dashboard')
            return
          }
          data.forEach(brand => {
            this.brands.push({id: brand.id, name: brand.name})
          })
          if (this.currentTicketBrandId) {
            this.brandId = this.currentTicketBrandId
            this.brandName = this.currentTicketBrandName
          } else {
            if (data.length > 0) {
              this.brandId = data[0].id
              this.brandName = data[0].name
              this.changeTicketBrandId(this.brandId)
              this.changeTicketBrandName(this.brandName)
            } else {
              this.changeTicketBrandId(null)
              this.changeTicketBrandName(null)
            }
          }
        } else {
          this.$alertMsg(result.data.message)
        }
      })
        .then(() => this.searchTicketBrand())
    },
    searchTicketBrand () {
      if (this.brands.length > 0) {
        this.changeTicketBrandId(this.brandId)
        this.changeTicketBrandName(this.brandName)
        if (this.currentTicketBrandId) {
          eventBus.$emit(eventType.FETCH_TICKET_BRAND)
          eventBus.$emit(eventType.REFRESH_TICKET_COUNT)
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/templates/header/fragments/BrandSelect.vue